import { render, staticRenderFns } from "./ReportCenterList.vue?vue&type=template&id=ed38d518"
import script from "./ReportCenterList.vue?vue&type=script&lang=js"
export * from "./ReportCenterList.vue?vue&type=script&lang=js"
import style0 from "./ReportCenterList.vue?vue&type=style&index=0&id=ed38d518&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports